import React from 'react';

const GovernmentServices: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">সরকারি সেবা ও গুরুত্বপূর্ণ লিংক</h2>
          <p className="text-gray-600">Government Services and Important Links</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* জরুরী লিংক - Essential Links */}
          <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200">
            <h3 className="text-xl font-semibold text-blue-800 mb-6 flex items-center">
              🔗 জরুরী লিংক (Essential Links)
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <a href="https://www.bangladesh.gov.bd/" target="_blank" rel="noopener noreferrer" className="flex items-center p-2 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                <i className="fas fa-check-circle text-green-600 mr-2"></i>
                <span className="text-sm">বাংলাদেশ জাতীয় তথ্য বাতায়ন</span>
              </a>
              <a href="https://www.banbeis.gov.bd/" target="_blank" rel="noopener noreferrer" className="flex items-center p-2 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                <i className="fas fa-check-circle text-green-600 mr-2"></i>
                <span className="text-sm">ব্যানবেইস</span>
              </a>
              <a href="https://www.nctb.gov.bd/" target="_blank" rel="noopener noreferrer" className="flex items-center p-2 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                <i className="fas fa-check-circle text-green-600 mr-2"></i>
                <span className="text-sm">এনসিটিবি</span>
              </a>
              <a href="https://www.teachers.gov.bd/" target="_blank" rel="noopener noreferrer" className="flex items-center p-2 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                <i className="fas fa-check-circle text-green-600 mr-2"></i>
                <span className="text-sm">শিক্ষক বাতায়ন</span>
              </a>
              <a href="https://www.muktopaath.gov.bd/" target="_blank" rel="noopener noreferrer" className="flex items-center p-2 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                <i className="fas fa-check-circle text-green-600 mr-2"></i>
                <span className="text-sm">মুক্তপাঠ</span>
              </a>
              <a href="https://www.educationboard.gov.bd/" target="_blank" rel="noopener noreferrer" className="flex items-center p-2 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                <i className="fas fa-check-circle text-green-600 mr-2"></i>
                <span className="text-sm">শিক্ষা বোর্ড</span>
              </a>
              <a href="https://emis.gov.bd/" target="_blank" rel="noopener noreferrer" className="flex items-center p-2 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                <i className="fas fa-check-circle text-green-600 mr-2"></i>
                <span className="text-sm">EMIS</span>
              </a>
              <a href="https://www.pmest.gov.bd/" target="_blank" rel="noopener noreferrer" className="flex items-center p-2 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                <i className="fas fa-check-circle text-green-600 mr-2"></i>
                <span className="text-sm">প্রধানমন্ত্রীর শিক্ষা সহায়তা ট্রাস্ট</span>
              </a>
            </div>
          </div>

          {/* সরকারি সেবা - Government Services */}
          <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200">
            <h3 className="text-xl font-semibold text-green-800 mb-6 flex items-center">
              🌐 সরকারি সেবা (Government Services)
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <button className="flex items-center p-2 bg-green-50 rounded-lg hover:bg-green-100 transition-colors text-left">
                <i className="fas fa-file-alt text-green-600 mr-2"></i>
                <span className="text-sm">একাডেমিক রেকর্ড</span>
              </button>
              <button className="flex items-center p-2 bg-green-50 rounded-lg hover:bg-green-100 transition-colors text-left">
                <i className="fas fa-chart-bar text-green-600 mr-2"></i>
                <span className="text-sm">ফলাফল যাচাই</span>
              </button>
              <button className="flex items-center p-2 bg-green-50 rounded-lg hover:bg-green-100 transition-colors text-left">
                <i className="fas fa-users text-green-600 mr-2"></i>
                <span className="text-sm">শিক্ষক তালিকা</span>
              </button>
              <button className="flex items-center p-2 bg-green-50 rounded-lg hover:bg-green-100 transition-colors text-left">
                <i className="fas fa-edit text-green-600 mr-2"></i>
                <span className="text-sm">ভর্তির আবেদন</span>
              </button>
              <button className="flex items-center p-2 bg-green-50 rounded-lg hover:bg-green-100 transition-colors text-left">
                <i className="fas fa-book text-green-600 mr-2"></i>
                <span className="text-sm">নতুন প্রকাশনা</span>
              </button>
              <button className="flex items-center p-2 bg-green-50 rounded-lg hover:bg-green-100 transition-colors text-left">
                <i className="fas fa-external-link-alt text-green-600 mr-2"></i>
                <span className="text-sm">Official Link</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GovernmentServices;
